import React from "react";

import Tooltip from "@mui/material/Tooltip";
import { AiFillInteraction } from "react-icons/ai";
import { AnimatePresence } from "framer-motion";
import { connect } from "react-redux";
import { setcontactlist } from "../../../../../Redux/Actions/actions";
// Component
import UserDetails from "./User-Details.component";
import Interactiontab from "./user-list-child-component/Interaction-tab.component";



const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const UserlistComponent = (props) => {
  const { selectedCustomer } = props;

  return (
    <>
      <div className="details-user-chat borde r-bottom p-0">
        <div className="chat-profile-userlist d-flex justify-content-between align-items-center p-2">
          <UserDetails selectedCustomer={selectedCustomer} />
        </div>
      </div>

      <div className="chat-tabs">
        <ul
          className="nav nav-pills border-bottom border-top p-2 "
          id="pills-tab"
          role="tablist"
          style={{ justifyContent: "space-around" }}
        >
          <Tooltip title="Interaction History" arrow placement="top">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-home"
                type="button"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
                style={{
                  boxShadow:
                    "inset 5px 5px 6px #245793, inset -5px -5px 6px #2da3ff",
                  fontWeight: 600,
                }}
              >
                <AiFillInteraction size={17} />
              </button>
            </li>
          </Tooltip>
        </ul>

        <div className="tab-content" id="pills-tabContent">
          <AnimatePresence mode="wait">
            <Interactiontab selectedCustomer={selectedCustomer} />
          </AnimatePresence>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setcontactlist,
})(UserlistComponent);
